<div class="row">
    <div class="col-xl-4">
        <div class="card card-box text-center p-4 mb-5">
            <div class="avatar-icon-wrapper rounded-circle mx-auto">
                <div class="d-block p-0 avatar-icon-wrapper rounded-circle m-0 border-3 border-first">
                    <div class="rounded-circle border-3 border-white overflow-hidden">
                        <img alt="..." class="img-fluid" src="assets/images/avatars/avatar5.jpg"/>
                    </div>
                </div>
            </div>
            <h4 class="font-size-lg font-weight-bold my-2">
                Marion Devine
            </h4>
            <div class="text-center my-4">
                <span class="badge badge-pill bg-neutral-first text-first mx-1">
                    Web developer
                </span>
                <span class="badge badge-pill bg-neutral-warning text-warning mx-1">
                    Javascript
                </span>
                <span class="badge badge-pill bg-neutral-danger text-danger mx-1">
                    Angular
                </span>
            </div>

            <p class="text-muted mb-4">I should be incapable of drawing a single stroke at the present moment; and yet I feel that I never was a greater artist than now.</p>

            <div class="d-flex justify-content-between text-center line-height-sm font-size-lg text-black-50">
                <div>
                    <div class="text-second font-weight-bold">
                        86%
                    </div>
                    <small>Profile completion</small>
                </div>
                <div>
                    <div class="text-second font-weight-bold">
                        $1,864
                    </div>
                    <small>Lifetime earnings</small>
                </div>
                <div>
                    <div class="text-second font-weight-bold">
                        241
                    </div>
                    <small>Projects completed</small>
                </div>
            </div>
        </div>
    </div>
    <div class="col-xl-4">
        <div class="card card-box text-center p-4 mb-5">
            <div class="avatar-icon-wrapper rounded-circle mx-auto">
                <div class="d-block p-0 avatar-icon-wrapper rounded-circle m-0 border-3 border-danger">
                    <div class="rounded-circle border-3 border-white overflow-hidden">
                        <img alt="..." class="img-fluid" src="assets/images/avatars/avatar4.jpg"/>
                    </div>
                </div>
            </div>
            <h4 class="font-size-lg font-weight-bold my-2">
                Charlotte Vasquez
            </h4>
            <div class="text-center my-4">
                <span class="badge badge-pill bg-neutral-first text-first mx-1">
                    UX Designer
                </span>
                <span class="badge badge-pill bg-neutral-warning text-warning mx-1">
                    Software Architect
                </span>
                <span class="badge badge-pill bg-neutral-danger text-danger mx-1">
                    React
                </span>
            </div>

            <p class="text-muted mb-4">To an English person, it will seem like simplified English, as a skeptical Cambridge friend of mine told me what Occidental is.</p>

            <div class="d-flex justify-content-between text-center line-height-sm font-size-lg text-black-50">
                <div>
                    <div class="text-second font-weight-bold">
                        44%
                    </div>
                    <small>Profile completion</small>
                </div>
                <div>
                    <div class="text-second font-weight-bold">
                        $12,547
                    </div>
                    <small>Lifetime earnings</small>
                </div>
                <div>
                    <div class="text-second font-weight-bold">
                        347
                    </div>
                    <small>Projects completed</small>
                </div>
            </div>
        </div>
    </div>
    <div class="col-xl-4">
        <div class="card card-box text-center p-4 mb-5">
            <div class="avatar-icon-wrapper rounded-circle mx-auto">
                <div class="d-block p-0 avatar-icon-wrapper rounded-circle m-0 border-3 border-success">
                    <div class="rounded-circle border-3 border-white overflow-hidden">
                        <img alt="..." class="img-fluid" src="assets/images/avatars/avatar3.jpg"/>
                    </div>
                </div>
            </div>
            <h4 class="font-size-lg font-weight-bold my-2">
                Sidney Pearson
            </h4>
            <div class="text-center my-4">
                <span class="badge badge-pill bg-neutral-first text-first mx-1">
                    Project Manager
                </span>
                <span class="badge badge-pill bg-neutral-warning text-warning mx-1">
                    ECMA Script
                </span>
                <span class="badge badge-pill bg-neutral-danger text-danger mx-1">
                    Vue.js
                </span>
            </div>

            <p class="text-muted mb-4">If several languages coalesce, the grammar of the resulting language is more simple and regular than that of the individual languages.</p>

            <div class="d-flex justify-content-between text-center line-height-sm font-size-lg text-black-50">
                <div>
                    <div class="text-second font-weight-bold">
                        64%
                    </div>
                    <small>Profile completion</small>
                </div>
                <div>
                    <div class="text-second font-weight-bold">
                        $764
                    </div>
                    <small>Lifetime earnings</small>
                </div>
                <div>
                    <div class="text-second font-weight-bold">
                        226
                    </div>
                    <small>Projects completed</small>
                </div>
            </div>
        </div>
    </div>
</div>
